/**
 * @param {Object} selector of the element that triggers the reveal when scrolled past
 * @param {Object} selector of the element you want to show and hide
 * @param {Boolean} (optional) whether the reveal should fade in and out
 */

import { throttle } from 'throttle-debounce'
import slugify from 'slugify'

const revealElement = (elToScrollPast, elToShow, animate = false) => {
  let elementToScrollPast = document.querySelector(elToScrollPast)
  let elementToShow = document.querySelector(elToShow)
  var elementToShowActive = elToShow + '--active'
  var elementToShowActive = slugify(elementToShowActive, {
    strict: true,
    trim: true,
  })
  const animationIn = animate ? ['o-animate', 'o-animate--fast', 'o-animate--fade-in'] : 'block'
  const animationOut = animate ? ['o-animate', 'o-animate--fast', 'o-animate--fade-out'] : 'hidden'
  var initialState = false

  if (!elementToShow || !elementToScrollPast || !elementToShowActive) return

  const calculate = throttle(1000, (num) => {
    const currentOffset = window.pageYOffset
    const elementToScrollPastHeight = elementToScrollPast.offsetTop + elementToScrollPast.offsetHeight

    if (currentOffset >= elementToScrollPastHeight) {
      elementToShow.classList.remove(...animationOut)
      elementToShow.classList.add(...animationIn)
      elementToShow.classList.add(elementToShowActive)
      initialState = true
    } else {
      if (initialState) {
        elementToShow.classList.remove(...animationIn)
        elementToShow.classList.remove(elementToShowActive)
        elementToShow.classList.add(...animationOut)
      }
    }
  })

  window.addEventListener('scroll', () => {calculate()})
  window.addEventListener('load', () => {calculate()})
}

export default revealElement
